// Hero.js (example)
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import CallToAction from './Shared/CallToAction';
import {base} from './Config/app';
import {Ts, LangSwitcher} from './Config/Lang/switcher';


const Hero = ({lang}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  const T = (value, key='home') => Ts(lang, key, value)

  useEffect(() => {
//    const trigger = useScrollTrigger({ onEnter: () => setIsScrolled(true), onLeave: () => setIsScrolled(false) });
//    return () => trigger.cleanup();
  }, []);


  return (
    <HeroContainer id="about">
      <h1 className='brillant'>{T('title','about')}</h1>
      <h6 className='brillant'>{T('content','about')}</h6>
    </HeroContainer>
  );
};


const HeroContainer = styled.div`
max-width: 1024px;
margin: auto;
  background-image: url('landing.jpg');
  background-size: cover; /* contain; */
  background-position: center;
  height: 90vh;
  opacity: 0.9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-repeat: no-repeat;
  background-color: rgb(242,251,254);
  align-items: center;
  color: #fff;
`;

export default Hero;

